export default {
    DIVISIONS_SUCCESS(state, data) {
       state.divisionList = data;
     },
   
     DIVISIONS_FAILURE(state) {
       state.divisionList = null;
     },

     ROLES_SUCCESS(state, data) {
        state.roleList = data;
      },
    
      ROLES_FAILURE(state) {
        state.roleList = null;
      },
   }